import { Text } from '@zillow/constellation';
import type { Answers } from '../../../../../graphql/queries';
import { getAnswersForFields } from '../../../../../utils/overview/overview-display';
import { FIELD_IDS } from '../../../../../constants/wizard';

interface Props {
  answers: Answers;
}

const fieldsInStep = [FIELD_IDS.FIRST_NAME, FIELD_IDS.MIDDLE_NAME, FIELD_IDS.LAST_NAME];

export function LegalNameOverview({ answers }: Props) {
  const answersForFields = getAnswersForFields({ fieldIds: fieldsInStep, answers });

  const legalName = `${answersForFields[FIELD_IDS.FIRST_NAME] ? answersForFields[FIELD_IDS.FIRST_NAME] : ''}${
    answersForFields[FIELD_IDS.MIDDLE_NAME] ? ` ${answersForFields[FIELD_IDS.MIDDLE_NAME]}` : ''
  }${answersForFields[FIELD_IDS.LAST_NAME] ? ` ${answersForFields[FIELD_IDS.LAST_NAME]}` : ''}`;

  return <>{legalName && <Text>{legalName}</Text>}</>;
}
